<template>
    <div>
        <div v-if="flagged_orders_loading_status == true" class="text-center">
            <b-spinner small type="grow"></b-spinner>
            Loading flagged orders...
        </div>
        <div v-else>
            <simpleLayout :items_count="flagged_orders.length">
                <template #buttons>
                    <button type="button" class="btn btn-success mb-2 mr-2" @click="exportToExcel('flaggedOrdersTable')">
                        <i class="mdi mdi-file-excel mr-1"></i> Export to Excel
                    </button>
                </template>
                <template #content>
                    <flaggedOrdersTable />
                </template>
            </simpleLayout>
        </div>
    </div>
</template>

<script>
import { orderMethods, orderComputed, adminComputed } from "@/state/helpers";
import simpleLayout from "@/components/layout-templates/simple-layout.vue";
import flaggedOrdersTable from "./flaggedOrdersTable.vue";

export default {
    components: { simpleLayout, flaggedOrdersTable },
    data: () => ({
        ready: false,
    }),
    computed: {
        ...orderComputed,
        ...adminComputed,
    },
    methods: {
        ...orderMethods,
        exportToExcel(id) {
            /* eslint-disable */
            return webix.toExcel($$(id), {
                ignore: { actions: true },
                filename: _.uniqueId("flaggedOrdersExport_"),
                name: "Flagged Orders",
            });
            /* eslint-enable */
        },
    },
    mounted() {
        this.getFlaggedOrders().then(() => {
            this.ready = true;
        });
    },
};
</script>
